import { RootState } from "../store/configureStore";

export const selectIsFetchingForceOrderStatus = (state: RootState) =>
  state.dev.isFetchingForceOrderStatus;
export const selectIsFetchingForceEircodeStatus = (state: RootState) =>
  state.dev.isFetchingForceEircodeStatus;
export const selectIsFetchingForceOrderMissionNull = (state: RootState) =>
  state.dev.isFetchingForceOrderMissionNull;
export const selectIsFetchingCompleteMission = (state: RootState) =>
  state.dev.isFetchingCompleteMission;
